<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box-header align-items-center">
      <h2>{{pageTitle}}</h2>
    </b-row>
    <b-row no-gutters class="bordered-box">
      <b-form @submit.prevent="onSubmit" class="col-12">
        <b-form-group class="required" label="Dziedzina">
          <b-form-input
            v-model="domain"
            :state="$v.domain.$error? false : null"
            @input="$v.domain.$reset()"
            type="text"
            autocomplete="off"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.domain.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="required" label="Tytuł">
          <b-form-input
            v-model="title"
            :state="$v.title.$error? false : null"
            @input="$v.title.$reset()"
            type="text"
            autocomplete="off"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.title.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="required" label="Opis">
          <b-form-textarea
            v-model="description"
            :state="$v.description.$error? false : null"
            @input="$v.description.$reset()"
            rows="6"
            max-rows="6"
            autocomplete="off"
          />
          <b-form-invalid-feedback>
            <div v-if="!$v.description.required">To pole jest wymagane</div>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="text-right">
          <hr />
          <b-button
            type="submit"
            variant="primary"
            class="mr-1"
            :disabled="saving"
            @click="$v.$touch"
          >
            <span v-show="!saving">Zapisz</span>
            <span v-show="saving">
              <b-spinner small label="Proszę czekać..."></b-spinner>
            </span>
          </b-button>
          <b-button class="mr-1" variant="secondary" @click="$router.go(-1)">Powrót</b-button>
          <b-button variant="link" @click="goToDetails" v-if="subjectId">Szczegóły</b-button>
        </b-form-group>
      </b-form>
    </b-row>
  </b-container>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      saving: false,
      title: null,
      subjectId: this.id,
      description: null,
      domain: null
    };
  },
  computed: {
    pageTitle() {
      if (this.subjectId) {
        return "Edycja tematu";
      } else {
        return "Utwórz nowy temat";
      }
    }
  },
  props: ["id"],
  validations: {
    title: { required },
    domain: { required },
    description: { required }
  },
  mounted() {
    if (this.id) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });
      axios
        .get("/templatesubjects/edit", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data;

          this.subjectId = result.id;
          this.title = result.title;
          this.description = result.description;
          this.domain = result.domain;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    }
  },
  methods: {
    goToDetails() {
      this.$router.push({ path: `/site/subjects/details/${this.subjectId}` });
    },
    onSubmit() {
      if (!this.$v.$error) {
        this.saving = true;

        axios[this.subjectId ? "put" : "post"]("/templatesubjects", {
          id: this.subjectId,
          title: this.title,
          description: this.description,
          domain: this.domain
        })
          .then(response => {
            var result = response.data;

            this.subjectId = result.id;
            this.title = result.title;
            this.description = result.description;
            this.domain = result.domain;

            eventBus.$emit("notify-success", "Zapisano poprawnie.");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => (this.saving = false));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>